import DrawerRadioGroup from './DrawerRadioGroup';

interface DrawerBoolGroupProps {
    value?: string;
    onChange?: (value: string | boolean) => void;
    disabled?: boolean;
}

export const DrawerBoolGroup: React.FC<DrawerBoolGroupProps> = ({ value, onChange, disabled }) => {
    return (
        <DrawerRadioGroup
            options={
                new Map([
                    ['Yes', true],
                    ['No', false],
                ])
            }
            value={value}
            onChange={onChange}
            disabled={disabled}
        />
    );
};

export default DrawerBoolGroup;
